import "./App.css";
import { FormularioQA } from "./pages/Formulario";
import { Home } from "./pages/Home/index";
import { BrowserRouter, Route, Routes } from "react-router-dom";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/formulario" element={<FormularioQA />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
